var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWallet = function SvgWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9285 13.875H10.0714C6.16603 13.875 2.99995 16.9531 2.99995 20.75C2.99995 21.4402 3.57571 22 4.28567 22H19.7142C20.4242 22 21 21.4402 21 20.75C21 16.9531 17.8339 13.875 13.9285 13.875ZM4.9683 20.125C5.28571 17.6602 7.45174 15.75 10.0714 15.75H13.9285C16.5466 15.75 18.7138 17.6621 19.0312 20.125H4.9683ZM12 12C14.8402 12 17.1428 9.76133 17.1428 7C17.1428 4.23867 14.8402 2 12 2C9.15973 2 6.8571 4.23867 6.8571 7C6.8571 9.76172 9.15933 12 12 12ZM12 3.875C13.7722 3.875 15.2142 5.27695 15.2142 7C15.2142 8.72305 13.7722 10.125 12 10.125C10.2277 10.125 8.78567 8.72266 8.78567 7C8.78567 5.27695 10.2281 3.875 12 3.875Z",
    fill: "#B7B7B9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet.5d50be74.svg";
export { ForwardRef as ReactComponent };